import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class FileTransferService {
  private files: File[] | null = null;

  setFiles(files: File[]): void {
    this.files = files;
  }

  getFiles(): File[] | null {
    const f = this.files;
    this.clear();
    return f;
  }

  clear(): void {
    this.files = null;
  }
}
